import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, Checkbox, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, RadioGroup, Radio, FormControlLabel, TextField, Skeleton, Select, MenuItem } from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import { UserListHead, UserListToolbar } from "../../components/_dashboard/user";
// import USERLIST from '../_mocks_/user';

import axios from "axios";
import { DATA_TYPES, IMG_BASE_URL, INPUT_TYPES } from "src/config/constants";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { alert } from "src/services/alert";
import Confirm from "src/components/common/ConfirmDialog";
import ListHead from "src/components/common/ListHead";
import MyPagination from "src/components/common/MyPagination";
import ListToolbar from "src/components/common/ListToolbar";

const inputTypes = Object.keys(INPUT_TYPES);
const dataTypes = Object.keys(DATA_TYPES);

const TABLE_HEAD = [
  { id: "id", label: "配置ID", alignRight: false }, 
  { id: "name", label: "名称", alignRight: false }, 
  { id: "key", label: "变量名", alignRight: false }, 
  { id: "inputType", label: "输入类型", alignRight: false }, 
  { id: "dataType", label: "值类型", alignRight: false }, 
  { id: "value", label: "值", alignRight: false }, 
  { id: "visible", label: "是否显示", alignRight: false }, 
  { id: "createdAt", label: "创建时间", alignRight: false }, 
  { id: "" }
];

const moreMenus = [
  { title: "编辑", icon: iconEdit },
  { title: "删除", icon: iconDelete },
];

export default function SystemConfigList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});
  const [form, setForm] = useState({
    name: "",
    key: "",
    inputType: 'TEXT',
    dataType: 'STRING',
    value: "",
    desc: "",
    isShow: 1,
  });

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  function handleRefresh() {
    setItems(null);
    getItems();
  }

  function getItems() {
    axios
      .post("/system/config/list", filter)
      .then((res) => {
        const { code, msg, data, count } = res.data;
        if (code === 1) {
          setItems(data);
          setTotal(count);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleAddBanner() {
    setForm({
      name: "",
      key: "",
      inputType: 'TEXT',
      dataType: 'STRING',
      value: "",
      desc: "",
      isShow: 1,
    });
    setAction("add");
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`edit/${row.id}`);
      setTargetItem({ ...row });
      setAction("edit");
      setForm({
        name: row.name,
        key: row.key,
        inputType: row.inputType,
        dataType: row.dataType,
        value: row.value,
        desc: row.desc,
        isShow: row.isShow,
      });
    } else if (type === "删除") {
      handleDelBanner(row.id);
    }
  };

  function handleDelBanner(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/system/config/del", { id })
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              setItems(items.filter((b) => b.id !== id));
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除配置失败: ", err);
          });
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function handleDialogConfirm() {
    if (!form.name || !form.key) return alert("信息不全");

    const formData = { ...form };

    if (action === "edit") {
      formData.id = targetItem.id;
    }

    axios
      .post(action === "add" ? "/system/config/add" : "/system/config/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (action === "add") {
            setItems([...items, data]);
          } else if (action === "edit") {
            const item = items.find((b) => b.id === targetItem.id);
            Object.assign(item, form);
            setItems([...items]);
          }

          setAction("");
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改配置失败: ", err);
      });
  }

  return (
    <Page title="开发配置">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            开发配置
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddBanner}>
            添加配置
          </Button>
        </Stack>

        {!items ? (
          <Card>
            <Stack spacing={1} padding={2}>
              <Skeleton variant="rectangular" animation="wave" height={30} />
              <Skeleton variant="rectangular" animation="wave" height={30} />
              <Skeleton variant="rectangular" animation="wave" height={30} />
            </Stack>
          </Card>
        ) : (
          <Card>
            <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={handleRefresh} />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <ListHead headLabel={TABLE_HEAD} />

                  <TableBody>
                    {items.map((row) => {
                      // const { id, name, role, status, company, avatarUrl, isVerified } = row;
                      const { id, name, key, inputType, dataType, value, isShow, createdAt } = row;

                      return (
                        <TableRow hover key={id} tabIndex={-1}>
                          {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell>
                          */}
                          <TableCell align="left">{id}</TableCell>
                          <TableCell align="left">{name}</TableCell>
                          <TableCell align="left">{key}</TableCell>
                          <TableCell align="left">{inputType}</TableCell>
                          <TableCell align="left">{dataType}</TableCell>
                          <TableCell align="left">{value}</TableCell>
                          <TableCell align="left">
                            <Switch checked={!!isShow} />
                          </TableCell>

                          <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                          <TableCell align="right">
                            <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                  {items.length === 0 && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filter.search} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
          </Card>
        )}
      </Container>

      <FormDialog contentWidth={600} title={action === "add" ? "添加配置" : "修改配置"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="名称" required>
          <TextField fullWidth placeholder="请输入名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
        </FormItem>

        <FormItem title="变量名" required>
          <TextField fullWidth placeholder="请输入变量名" autoComplete="off" id="key" value={form.key} size="small" onChange={(e) => handleIptChange("key", e.target.value)} />
        </FormItem>

        <FormItem title="输入类型" required>
          <Select value={form.inputType} onChange={e => handleIptChange('inputType', e.target.value)}>
            {inputTypes.map(t => (
              <MenuItem key={t} value={t}>{t}</MenuItem>
            ))}
          </Select>
        </FormItem>

        <FormItem title="值类型" required>
          <Select value={form.dataType} onChange={e => handleIptChange('dataType', e.target.value)}>
            {dataTypes.map(t => (
              <MenuItem key={t} value={t}>{t}</MenuItem>
            ))}
          </Select>
        </FormItem>

        <FormItem title="默认值" required>
          <TextField fullWidth placeholder="请输入默认值" autoComplete="off" id="value" value={form.value} size="small" onChange={(e) => handleIptChange("value", e.target.value)} />
        </FormItem>

        <FormItem title="说明">
          <TextField fullWidth multiline rows={3} placeholder="请输入说明" autoComplete="off" id="desc" value={form.desc} size="small" onChange={(e) => handleIptChange("desc", e.target.value)} />
        </FormItem>

        <FormItem title="是否显示" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
            <FormControlLabel value={1} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
            <FormControlLabel value={0} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
          </RadioGroup>
        </FormItem>
      </FormDialog>
    </Page>
  );
}
